import { isUndefinedOrNull } from "@daytrip/utils";

import { Position } from "../models/Position";

export const transformPositionStringToPosition = (positionString: string): Position | undefined => {
    if (isUndefinedOrNull(positionString)) {
        return undefined;
    }

    const [lat, long] = positionString.split(",");
    if (!lat || !long) {
        return undefined;
    }
    return new Position(Number(lat), Number(long));
};
